import { createFileRoute, redirect } from "@tanstack/react-router";
import { ApiError, fetchMe, qk } from "@/lib/api";
import { ApprovePage } from "./-approve/ApprovePage";

/** Opened from approval links (push, email). Outside the app shell: it must work well on a phone. */
export const Route = createFileRoute("/approve/$approvalId")({
  staticData: { title: "Approve a request" },
  // Signs you in first if needed; loading `me` also arms the CSRF token that approving needs.
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData({ queryKey: qk.me(), queryFn: fetchMe });
    } catch (e) {
      if (e instanceof ApiError && (e.status === 401 || e.code === "unauthorized")) {
        throw redirect({ to: "/login", search: { next: location.href } });
      }
      throw e;
    }
  },
  component: ApprovePage,
});
